/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { LocalStorageService } from "@hcworkspace/sysque/toolbelt/utils";
import { PanelCircuitDataReturnCodes } from "../models/panel-circuit-data-return-codes";

export class ApplyPanelDataReceiveController {

    constructor(private localStorageService: LocalStorageService) { }

    public ApplyPanelDataResult(response: PanelCircuitDataReturnCodes): void {
        this.localStorageService.updateDispatchLocalStorage('applyPanelDataResponse', response);
    }
}
